import React from "react";

import { StringParam, useQueryParam, withDefault } from "use-query-params";

import { INHERIT_BUDGET_MIX_KPI } from "@features/mmm/hooks/mmm-url-state";

export const getRoasDataStateInitialValue = () => INHERIT_BUDGET_MIX_KPI;

export const useRoasDataState = () => {
  return useQueryParam(
    "roas-data",
    withDefault(StringParam, getRoasDataStateInitialValue()),
  );
};
